import {createWebHashHistory, createRouter } from 'vue-router'

import IndexPage from '@/pages/IndexPage'

const routes = [
    { path: '/', component: IndexPage, meta: {title: '賞金獵人實時監控系統'}},
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router;